import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { translate } from 'react-i18next'
import { NotificationManager } from 'react-notifications'

import { Form, TextInput, SelectInput, BirthdayInput } from '../../UI'
import Loader from '../../UI/Loader'

import { validateRequired, validateRequiredBirthday } from '../../../libs/validation'

import USER_PROFILE_BY_USER_QUERY from './../../../graphql/UserByID.graphql'
import UPDATE_USER_PROFILE_QUERY from './../../../graphql/UpdateUserProfile.graphql'

import get from 'lodash/get'


class DetailsForm extends Component {
  state = {
    saving: false,
    routeIndex: 0
  }

  componentDidMount() {
    console.log('componentDidMount')
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState(() => ({
      saving: true
    }))

    this.props
      .updateUserProfile({
        variables: {
          id: this.props.data.user.userProfile.id,
          firstName: values.firstName,
          lastName: values.lastName,
          birthDate: values.birthDate,
          gender: values.gender
        }
      })
      .then(() => {
        NotificationManager.success('Details updated', 'Success', 5000)
        this.setState(
          () => ({
            saving: false
          }),
          () => {
            this.props.data.refetch()
            this.props.history.push('/create-guru-profile/description')
          }
        )
      })
      .catch(err => {
        this.setState(() => ({
          saving: false
        }))
        NotificationManager.error('Error while updating details', 'Error', 5000)
      })
  }

  getGenderOptions = () => {
    return [
      {
        label: 'male',
        value: 'male'
      },
      {
        label: 'female',
        value: 'female'
      },
      {
        label: 'other',
        value: 'other'
      }
    ]
  }

  render() {
    const { t, data } = this.props

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { firstName, lastName, birthDate, gender } = data.user[0].userProfile[0]
    const { saving } = this.state
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('my_details')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="row">
            <div className="form-group clearfix">
              <div className="col-md-9">
                <TextInput
                  id="firstName"
                  placeholder="John"
                  initialValue={firstName}
                  maxChars={50}
                  validationFuncs={[validateRequired]}
                  extraClass=""
                  label={t('main:first_name')}
                />
              </div>
            </div>

            <div className="form-group clearfix">
              <div className="col-md-9">
                <TextInput
                  id="lastName"
                  placeholder="Doe"
                  initialValue={lastName}
                  maxChars={50}
                  validationFuncs={[validateRequired]}
                  label={t('main:last_name')}
                  labelClass="steps-screen__form-input-label"
                />
              </div>
            </div>

            <div className="form-group clearfix">
              <div className="col-md-9">
                <label>{t('main:birthday')}</label>
                <BirthdayInput id="birthDate" initialValue={birthDate} isGroup={false} validationFuncs={[validateRequiredBirthday]} />
              </div>
            </div>

            <div className="form-group clearfix">
              <div className="col-md-4 ">
                <SelectInput
                  id="gender"
                  initialValue={gender}
                  options={this.getGenderOptions()}
                  validationFuncs={[validateRequired]}
                  label={t('main:gender')}
                  simpleValue
                  clearable={false}
                  isGroup={false}
                />
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('guru'),
  graphql(UPDATE_USER_PROFILE_QUERY, {
    name: 'updateUserProfile'
  }),
  graphql(USER_PROFILE_BY_USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  withRouter
)
export default enhance(DetailsForm)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/DetailsForm.jsx